import { Component, OnInit, ViewEncapsulation, Input, ViewChild } from '@angular/core';
import { DashboardService } from '../../dashboard/shared/dashboard.service';
import { RetentionRow } from '../../dashboard/shared/retention-row.model';
import { ChartData, ChartDataset } from 'src/app/shared/chart/chart-data.model';
import { ChartService } from 'src/app/shared/chart/chart.service';
import { UIChart } from 'primeng/chart';
import { TranslationService } from 'src/app/shared';

@Component({
  selector: 'wl-dashboard-neo-retention-donut',
  templateUrl: 'dashboard-neo-retention-donut.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [DashboardService, ChartService],
  styleUrls: ['dashboard-neo-retention-donut.component.less'],
    standalone: false
})
export class DashboardNeoRetentionDonutComponent implements OnInit {
  public startDate: Date;
  public endDate: Date;
  public isLoading: boolean;

  public chartData: ChartData;
  public chartOptions: any;
  public colors: string[];
  @ViewChild('retentionDonut') retentionDonut: UIChart;

  public constructor(
    private _dashboardService: DashboardService,
    private _translationService: TranslationService,
    private _chartService: ChartService
  ) {
    this.isLoading = true;

    this.chartOptions = {
      responsive: true,
      plugins: {
        legend: {
          position: false,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              let label = context.dataset.label || '';

              if (label) {
                label += ': ';
              }
              if (context.parsed !== null) {
                label += new Intl.NumberFormat('en-US', { style: 'percent' }).format(context.parsed);
              }
              return label;
            },
          },
        },
      },
      radius: 65,
    };
  }

  ngOnInit() {
    this.getRetentionReport();
  }

  public getRetentionReport() {
    this._dashboardService.getRetentionReport(this.startDate, this.endDate).then((data: Array<RetentionRow>) => {
      this.chartData = new ChartData();
      this.calculateRetentionTotals(data);
      this.isLoading = false;
    });
  }

  private calculateRetentionTotals(data: RetentionRow[]): void {
    let amountPaid: number = data.reduce((amountPaid, current) => amountPaid + current.AmountPaid, 0);
    let amountBilled: number = data.reduce((amountBilled, current) => amountBilled + current.AmountBilled, 0);

    var totalRetained = amountPaid / amountBilled;

    //calculate retention percentages differently
    this.colors = this._chartService.getChartColors(2);
    this.chartData.labels.push(this._translationService.getInstantTitlecase('dashboard.retention.investment-retention'));
    this.chartData.datasets[0].data.push(totalRetained);
    this.chartData.datasets[0].backgroundColor = [this.colors[0]];
    this.chartData.datasets[0].hoverBackgroundColor = [this.colors[1]];
    this.chartData.datasets[0].label = this._translationService.getInstantTitlecase('dashboard.retention.investment-retention');

    if (totalRetained < 1) {
      this.chartData.datasets[0].data.push(1 - totalRetained);
      this.chartData.datasets[0].backgroundColor.push('#ffffff');
    }

    if (this.retentionDonut) {
      this.retentionDonut.refresh();
    }
  }
}
